import Marionette from "../../shared/marionette-mustache";
import { autoinject } from "aurelia-dependency-injection";
import { backboneViewProperties } from "../../decorators/backbone-properties";
import { BrowsePanelModel } from "../../old-browse/models/browse-panel";

const template = require<string>("../../old-browse/views/browse-panel.html");
const dom = {
   BROWSE_LINKS : ".browse-link",
   BROWSE_TABS : ".browse-tab",
   BROWSE_LOADER : ".browse-loading",
   BROWSE_PANEL : ".browse-panel",
   BROWSE_FILTER_INPUT : ".category-filter-box-input",
   PANEL_TYPE_OPTION : ".panel-type-option",
   BROWSE_FILTER_COUNTER: "#match-item-counter",
   NO_MATCH_FOUND: ".no-match-found"
};

@autoinject
@backboneViewProperties({
    template: template,
    tagName: "div",
    className: "browse-panel"
})
export class BrowsePanelView extends Marionette.ItemView<BrowsePanelModel> {
    constructor(options) {
        super(options);
        this.setupModelListeners();
    }

    public events(): Backbone.EventsHash {
        const events: Backbone.EventsHash = {};
        events["click " + dom.BROWSE_LINKS] = (e) => this.browseLinkClick(e);
        events["click " + dom.PANEL_TYPE_OPTION] = (e) => this.panelTypeClick(e);
        events["keyup " + dom.BROWSE_FILTER_INPUT] = (e) => this.browseFilterKeyUp(e);
        events["keydown " + dom.BROWSE_FILTER_INPUT] = (e) => this.browseFilterKeyDown(e);
        return events;
    }

    public onShow() {
        setTimeout(() => {
            this.$(dom.BROWSE_PANEL).removeClass("prep");
        }, 20);
        this.model.load().then(() => {
            this.render();
            this.setSelectedItem();
       });
    }

    private setupModelListeners() {
        this.listenTo(this.model, "change:Loading", this.loadingChanged);
        this.listenTo(this.model, "change:Value", this.valueChanged);
        this.listenTo(this.model, "change:SelectedType", this.selectedTypeChanged);
    }

    private loadingChanged(model: BrowsePanelModel, loading: boolean) {
        if (!loading) {
            this.$(dom.BROWSE_LOADER).hide();
        }
    }

    private panelTypeClick(e: JQueryMouseEventObject) {
        const target = $(e.currentTarget);
        if (target.hasClass("disabled")) {
            return;
        }
        const type = target.attr("data-panel-type");
        this.model.SelectedType = type;
    }

    private valueChanged(model: BrowsePanelModel, value: string) {
        const target = this.$(`${dom.BROWSE_LINKS}[data-id="${value}"]`).addClass("active");
        this.$(dom.BROWSE_LINKS).not(target).removeClass("active");
        target.addClass("active");
    }

    private setSelectedItem() {
        _.defer(() => {
            if (!this.model.id) {
                return;
            }
            const parts = this.model.id.split("_");
            if (parts === 1) {
                return;
            }
            const id = parts[1];
            this.$(`${dom.BROWSE_LINKS}[data-id="${id}"]`).addClass("active");

        });
    }

    private browseFilterKeyDown(e: JQueryKeyEventObject) {
        this.highlightFilterInputboxContent(e);
        if (e.which === 13) { /* if ENTER key pressed */
            e.preventDefault();
            return false;
        }
    }

    private browseFilterKeyUp(e: JQueryKeyEventObject) {
        this.$(dom.NO_MATCH_FOUND).hide();
        this.$(dom.BROWSE_LINKS).show();

        const filterText = $(e.currentTarget).text().toLowerCase().replace(/\u00a0/g, " ");

        const matches = this.$(dom.BROWSE_LINKS).filter((index, link) => {
            const isMatch = $(link).data("itemname").toLowerCase().indexOf(filterText) !== -1;
            return isMatch;
        });
        this.$(dom.BROWSE_LINKS).not(matches).hide();

        if (filterText === "") {
            this.removeHighlightFilterInputboxContent(e);
        }
        else {
            this.highlightFilterInputboxContent(e);
        }

        this.removeHighlight(e);
        if (matches.length > 0) {
            this.highlightText(matches, filterText);
        }
        else {
            this.$(dom.NO_MATCH_FOUND).show();
        }

        const filterCountMsg = matches.length + " of " +  this.$(dom.BROWSE_LINKS).length;
        this.$(dom.BROWSE_FILTER_COUNTER).text(filterCountMsg);

    }

    private removeHighlight(e: JQueryKeyEventObject) {
        this.$(dom.BROWSE_LINKS).each((index, item: HTMLElement) => {
            const txt = $(item).text();
            $(item).html(txt);
        });
    }

    private selectedTypeChanged(model: BrowsePanelModel, type: string) {
       this.model.load().then(() => {
           this.render();
       });
    }

    private browseLinkClick(e: JQueryMouseEventObject) {
        e.preventDefault();
        const target = $(e.currentTarget);
        const url = target.attr("href");
        this.$(dom.BROWSE_LINKS).not(target).removeClass("active");
        target.addClass("active");
        Backbone.history.navigate(url, {trigger: true});
    }

    private highlightText(matches: any, filterText: string) {
        if (filterText.length === 0) { return; }

        matches.each((index, item: HTMLElement) => {
            let text = $(item).data("itemname") as string;
            let matchIndex = text.toLowerCase().indexOf(filterText);
            const numDocs = $(item).data("numdocs");
            let position = 0;
            const before = "<span class='highlight'>";
            const after = "</span>";

            while (matchIndex >= 0) {
                const itemEnd = text.substr(matchIndex + filterText.length);
                const itemStart = text.substr(0, matchIndex);
                text = itemStart + before + text.substr(matchIndex, filterText.length) + after + itemEnd;

                position = before.length + after.length + matchIndex + 1;
                matchIndex = text.toLowerCase().indexOf(filterText, position);
            }

            const newValue = text; // + "<span class=\"browse-number\"> (" + numDocs + ")</span>";
            $(item).html(newValue);
        });
    }

    private highlightFilterInputboxContent(e: JQueryKeyEventObject) {
        const target = $(e.currentTarget);
        target.addClass("active");
    }

    private removeHighlightFilterInputboxContent(e: JQueryKeyEventObject) {
        const target = $(e.currentTarget);
        target.removeClass("active");
    }

}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/old-browse/views/browse-panel.ts